export type TimelineLayout = 'compact' | 'standard' | 'expanded';

export function layoutForHeight(h: number): TimelineLayout {
  if (h >= 108) return 'expanded';
  if (h >= 72) return 'standard';
  return 'compact';
}

/** Horizontal inset so edge markers (and playhead) are not clipped by overflow-hidden. */
export const TIMELINE_EDGE_INSET_PX = 12;

export function timelineMarkerLeftStyle(pct: number): Pick<import('react').CSSProperties, 'left'> {
  const p = Math.min(100, Math.max(0, pct));
  const i = TIMELINE_EDGE_INSET_PX;
  return {
    left: `calc(${i}px + (100% - ${i * 2}px) * ${p * 0.01})`,
  };
}

/** Map pointer X to 0..1 along the visible time axis (matches marker inset). */
export function timelineAxisMetrics(el: HTMLElement): { innerLeft: number; innerW: number } {
  const r = el.getBoundingClientRect();
  const cs = getComputedStyle(el);
  const pl = parseFloat(cs.paddingLeft) || 0;
  const pr = parseFloat(cs.paddingRight) || 0;
  const innerLeft = r.left + pl + TIMELINE_EDGE_INSET_PX;
  const innerW = Math.max(1, r.width - pl - pr - TIMELINE_EDGE_INSET_PX * 2);
  return { innerLeft, innerW };
}
